import { useEffect, useState } from 'react';

const getInitialValue = <T>(key: string) => {
  try {
    const storedValue = localStorage.getItem(key);
    return storedValue ? (JSON.parse(storedValue) as T) : undefined;
  } catch {
    localStorage.removeItem(key);
    return undefined;
  }
};

/** @deprecated please use import { useLocalStorage } from '@uidotdev/usehooks'; */
export const useLocalStorageState = <T>(localStorageKey: string) => {
  const [state, setState] = useState(getInitialValue<T>(localStorageKey));

  useEffect(() => {
    try {
      localStorage.setItem(localStorageKey, JSON.stringify(state));
    } catch {
      /** no-op: it's okay */
    }
  }, [localStorageKey, state]);

  return [state, setState] as [
    T | undefined,
    React.Dispatch<React.SetStateAction<T | undefined>>,
  ];
};
